'use client';

import dynamic from 'next/dynamic';
import type { CompactMapPoint } from './CompactMapPreviewLeaflet';

export type { CompactMapPoint } from './CompactMapPreviewLeaflet';

const LeafletCompactMapPreview = dynamic(
  () => import('./CompactMapPreviewLeaflet').then((module) => module.CompactMapPreviewLeaflet),
  { ssr: false, loading: () => <div className="h-64 animate-pulse rounded-card border border-line bg-surface-subtle" aria-busy="true" /> },
);

/** SSR-safe entry point for the bounded Leaflet implementation. */
export function CompactMapPreview(props: { points: CompactMapPoint[]; ariaLabel: string; className?: string }) {
  return <LeafletCompactMapPreview {...props} />;
}
